<template>
  <div>
    <b-sidebar v-if="can('Import contract') || can('Update contract')" id="sidebar-contrat-tier" ref="sideBarContratTier"
               backdrop bg-variant="white" no-header right shadow sidebar-class="sidebar-lg"
    >
      <template>
        <!-- Header -->
        <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
          <h5 class="mb-0 text-uppercase text-primary font-weight-bolder">
            <span>Enregistrer un contrat</span>
          </h5>
          

          <feather-icon class="ml-1 cursor-pointer" icon="XIcon" size="16" @click="hideSideBare"/>
        </div>
        <validation-observer ref="contratComposeRules">
          <b-form class="p-2" @submit.prevent="handleSubmit(onSubmit)" @reset.prevent="resetForm">
            <b-overlay :show="showLoading" no-wrap/>
            <!-- clients list -->
            <h4>INFORMATIONS</h4>
            <b-form-group v-if="isFormFicheTier" label="Client *" label-for="client">
              <validation-provider #default="{ errors }" name="client" :rules="isFormFicheTier ? '' : 'required'">
                <b-form-input
                id="basicInput"
                :value="prospectSelected.client"
                readonly
                />
                <b-form-invalid-feedback :state="errors.length > 0 ? false : null">{{ errors[0] }}</b-form-invalid-feedback>
                </validation-provider>
            </b-form-group>

            <b-form-group v-if="composeData.client && composeData.client.statutFiche === 'Prospect'" label="Souhaitez vous changer le statut du prospect en client ?">
              <b-form-radio-group
                  v-model="composeData.isChangedToProspect"
                  :options="optionsChangedToProspect"
                  class="demo-inline-spacing"
                  name="radio-inline"
              />
            </b-form-group>

            <h4>CONTRAT</h4>
            <!-- N contrat -->
            <b-form-group label="N° contrat*" label-for="num_contrat">
              <validation-provider #default="{ errors }" name="n° contrat" rules="required">
                <b-form-input id="num_contrat" v-model="composeData.n_contrat"
                              :state="errors.length > 0 ? false : null" placeholder="N° contrat"
                />
                <b-form-invalid-feedback :state="errors.length > 0 ? false : null">{{
                    errors[0]
                  }}
                </b-form-invalid-feedback>
              </validation-provider>
            </b-form-group>

            <!-- risque -->
            <b-form-group label="Risque*" label-for="Risque">
              <validation-provider #default="{ errors }" name="risque" rules="required">
                <b-form-select v-model="composeData.risque_id" :options="risquesOptions"
                               :state="errors.length > 0 ? false : null"
                >
                <template #first>
                    <b-form-select-option :value="null">-- Choisissez --</b-form-select-option>
                  </template>
                </b-form-select>
                <b-form-invalid-feedback :state="errors.length > 0 ? false : null">{{
                    errors[0]
                  }}
                </b-form-invalid-feedback>
              </validation-provider>
            </b-form-group>

            <!-- assureur -->
            <b-form-group label="Assureur*" label-for="assureur">
              <validation-provider #default="{ errors }" name="assureur" rules="required">
                <b-form-select v-model="composeData.assureur_id" :options="assureursOptions"
                               :state="errors.length > 0 ? false : null"
                >
              
                </b-form-select>
                <b-form-invalid-feedback :state="errors.length > 0 ? false : null">{{
                    errors[0]
                  }}
                </b-form-invalid-feedback>
              </validation-provider>
            </b-form-group>


            <!-- date d'effet -->
            <b-form-group label="Date d'effet*" label-for="date-effet">
              <validation-provider #default="{ errors }" name="date d'effet" rules="required">
                <flat-pickr id="date-effet" v-model="composeData.date_effet"
                            :class="errors.length > 0 ? 'is-invalid' : ''"
                            :config="configDate" class="form-control"
                            placeholder="Date d'effet"
                />
                <b-form-invalid-feedback :state="errors.length > 0 ? false : null">{{
                    errors[0]
                  }}
                </b-form-invalid-feedback>
              </validation-provider>
            </b-form-group>
            <!-- Echeance anniversaire -->
            <b-form-group label="Echéance anniversaire" label-for="echeance-anniversaire">
              <validation-provider #default="{ errors }" name="échéance d'anniversaire">
                <cleave
                  id="date"
                  v-model="composeData.echeance_anniversaire"
                  class="form-control"
                  :raw="false"
                  :options="options.date"
                  placeholder="jour/mois"
               />
                <div v-if="valdiation!=null" class="echent">Le champ date d'échéance invalide ( jj/mm )</div>
                <b-form-invalid-feedback :state="errors.length > 0 ? false : null">{{
                    errors[0]
                  }}
                </b-form-invalid-feedback>
              </validation-provider>
            </b-form-group>
 <!-- -->
 <b-form-group label="Contrat concurrence" label-for="contrat-concurrence">
              <validation-provider #default="{ errors }" name="Contrat concurrence">
                <div class="demo-inline-spacing" id="contrat-concurrence">
                  <b-form-radio v-model="composeData.concurrence" name="concurrence-radios" value="1"> oui </b-form-radio>
                  <b-form-radio v-model="composeData.concurrence" name="concurrence-radios" value="0"> non </b-form-radio>
                </div>
                <b-form-invalid-feedback :state="errors.length > 0 ? false : null">{{ errors[0] }} </b-form-invalid-feedback>
              </validation-provider>
            </b-form-group>
            <!-- Type de fractionnement -->
            <b-form-group label="Type de paiement" label-for="typeFractionnement">
                <b-form-select v-model="composeData.typeFractionnement" :options="typeFractionnementOptions"
                >
                
                </b-form-select>
            </b-form-group>

            <!-- statut -->
            <b-form-group label="Statut*" label-for="statut">
              <validation-provider #default="{ errors }" name="statut" rules="required">
                <b-form-select v-model="composeData.statut" :options="statutOptions"
                               :state="errors.length > 0 ? false : null"
                >
                <template #first>
                    <b-form-select-option :value="null">-- Choisissez --</b-form-select-option>
                  </template>
                </b-form-select>
                <b-form-invalid-feedback :state="errors.length > 0 ? false : null">{{
                    errors[0]
                  }}
                </b-form-invalid-feedback>
              </validation-provider>
            </b-form-group>
            <b-form-group label="Date de fin" label-for="date-fin" v-if="isRésilié || isTemporaire">
              <validation-provider #default="{ errors }" name="date de fin">
                <flat-pickr id="date-fin" v-model="composeData.date_fin" :class="errors.length > 0 ? 'is-invalid' : ''" :config="configDate" class="form-control" placeholder="Date de fin" />
                <b-form-invalid-feedback :state="errors.length > 0 ? false : null">{{ errors[0] }} </b-form-invalid-feedback>
              </validation-provider>
            </b-form-group>
            <!-- Modalité de paiement -->
            <b-form-group label="Modalité de paiement" label-for="Modalite_paiement">
              <!--              <validation-provider #default="{ errors }" name="modalité de paiement" rules="required">-->
              <b-form-select v-model="composeData.modalite_paiement" :options="modalitePaiementOptions"
              >
                <template #first>
                    <b-form-select-option :value="null">-- Choisissez --</b-form-select-option>
                  </template>
                </b-form-select>
              <!--              :state="errors.length > 0 ? false : null"-->
              <!--                <b-form-invalid-feedback :state="errors.length > 0 ? false : null">{{ errors[0] }}</b-form-invalid-feedback>-->
              <!--              </validation-provider>-->
            </b-form-group>

            <!-- budget -->
            <b-form-group label="Prime TTC" label-for="budget">
              <validation-provider #default="{ errors }" name="Prime TTC" >
                <cleave id="budget" v-model.trim="composeData.budget" :class="errors.length > 0 ? 'is-invalid' : ''"
                        :options="options.number" :raw="false" :state="errors.length > 0 ? false : null"
                        class="form-control" placeholder="10 000,00"
                />
                <div v-if="validbudget!=null" class="echent">Le champ Prime ttc est invalide </div>
                <b-form-invalid-feedback :state="errors.length > 0 ? false : null">{{
                    errors[0]
                  }}
                </b-form-invalid-feedback>
              </validation-provider>
            </b-form-group>

            <!-- taux de commission -->
            <validation-provider #default="{ errors }" name="taux de commission">
              <b-form-group label="Taux de commission" label-for="taux_commission">
                <b-input-group :class="errors.length > 0 ? 'is-invalid' : ''" append="%">
                  <cleave v-model.trim="composeData.taux_commission" :state="errors.length > 0 ? false : null" placeholder="10,00" class="form-control" :options="options.percent" :raw="false" />
                  </b-input-group>
                  <div v-if="validtaux_commission!=null" class="echent">Le champ taux de commission est invalide </div>

                <b-form-invalid-feedback :state="errors.length > 0 ? false : null">{{ errors[0] }} </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>

            <h4>RATTACHEMENT</h4>

            <!-- Courtier -->
            <b-form-group label="Courtier" label-for="courtier">
              <b-form-input id="courtier"
                            v-model="currentUser.courtier_user[0].courtier.personne_morale.denomination_commercial"
                            disabled placeholder="Courtier"
              />
            </b-form-group>

            <!-- utilisateur list -->
            <!-- <validation-provider #default="{ errors }" name="commercial" rules="required">
              <b-form-group :state="errors.length > 0 ? false : null" label="Commercial*" label-for="commercial">
                <v-select v-model="composeData.commercial" :close-on-select="true"
                          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" :options="commercialOptions"
                          class="flex-grow-1"
                          input-id="commercial" label="nom" placeholder="Commercial"
                >
                  <template #option="{ avatar, nom }">
                    <b-avatar :src="avatar" size="sm"/>
                    <span class="ml-50"> {{ nom }}</span>
                  </template>

                  <template #selected-option="{ avatar, nom }">
                    <b-avatar :src="avatar" class="border border-white" size="sm"/>
                    <span class="ml-50"> {{ nom }}</span>
                  </template>
                  <div slot="no-options">Aucune commercial disponible.</div>
                </v-select>
                <b-form-invalid-feedback :state="errors.length > 0 ? false : null">{{
                    errors[0]
                  }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider> -->
<h4>DOCUMENTS</h4>
             <app-collapse>
                <app-collapse-item title="Documents de souscription">
                  <b-form-group class="mt-2" label-for="h-document">
                  <validation-provider #default="{ errors }" name="document" >
                    <b-input-group>
                      <b-input-group-prepend>
                        <b-button v-ripple.400="'rgba(113, 102, 240, 0.15)'" class="btn-icon" :variant="errors.length > 0 ? 'outline-danger' : 'outline-primary'" v-b-tooltip.hover="'Conditions particulières'" @click="openConditionParticulier">
                          <b-form-file type="file" id="openConditionParticulier" class="d-none" v-model="composeData.fileConditionParticulier" />
                          <feather-icon icon="UploadCloudIcon" />
                        </b-button>
                      </b-input-group-prepend>
                      <b-form-input disabled placeholder="Conditions particulières" :value="composeData.fileConditionParticulier ? composeData.fileConditionParticulier.name : ''" :state="errors.length > 0 ? false : null" />
                    </b-input-group>
                  </validation-provider>
                </b-form-group>
                
                <b-form-group class="mt-2" label-for="h-document">
                  <validation-provider #default="{ errors }" name="document" >
                    <b-input-group>
                      <b-input-group-prepend>
                        <b-button v-ripple.400="'rgba(113, 102, 240, 0.15)'" class="btn-icon" :variant="errors.length > 0 ? 'outline-danger' : 'outline-primary'" v-b-tooltip.hover="'Bulletin d\'adhésion signé'" @click="openBulteinAdhesionSigne">
                          <b-form-file type="file" id="openBulteinAdhesionSigne" class="d-none" v-model="composeData.fileBulteinAdhésionSigne" />
                          <feather-icon icon="UploadCloudIcon" />
                        </b-button>
                      </b-input-group-prepend>
                      <b-form-input disabled placeholder="Bulletin d'adhésion signé" :value="composeData.fileBulteinAdhésionSigne ? composeData.fileBulteinAdhésionSigne.name : ''" :state="errors.length > 0 ? false : null" />
                    </b-input-group>    
                  </validation-provider>
                </b-form-group> 
                <b-form-group class="mt-2" label-for="h-document">
                  <validation-provider #default="{ errors }" name="document" >
                    <b-input-group>
                      <b-input-group-prepend>
                        <b-button v-ripple.400="'rgba(113, 102, 240, 0.15)'" class="btn-icon" :variant="errors.length > 0 ? 'outline-danger' : 'outline-primary'" v-b-tooltip.hover="'Fiche d\'information et de conseil'" @click="openFicheInformationConseil">
                          <b-form-file type="file" id="openFicheInformationConseil" class="d-none" v-model="composeData.fileFicheInformationConseil" />
                          <feather-icon icon="UploadCloudIcon" />
                        </b-button>
                      </b-input-group-prepend>
                      <b-form-input disabled placeholder="Fiche d'information et de conseil" :value="composeData.fileFicheInformationConseil ? composeData.fileFicheInformationConseil.name : ''" :state="errors.length > 0 ? false : null" />
                    </b-input-group>    
                  </validation-provider>
                </b-form-group> 
                </app-collapse-item>
                <app-collapse-item title="Documents produit">
                  <b-form-group class="mt-2" label-for="h-document"  >
                  <validation-provider #default="{ errors }" name="document" >
                    <b-input-group>
                      <b-input-group-prepend>
                        <b-button v-ripple.400="'rgba(113, 102, 240, 0.15)'" class="btn-icon" :variant="errors.length > 0 ? 'outline-danger' : 'outline-primary'" v-b-tooltip.hover="'IPID'" @click="openfileIpid">
                          <b-form-file type="file" id="openfileIpid" class="d-none" v-model="composeData.fileIpid" />
                          <feather-icon icon="UploadCloudIcon" />
                        </b-button>
                      </b-input-group-prepend>
                      <b-form-input disabled placeholder="IPID" :value="composeData.fileIpid ? composeData.fileIpid.name : ''" :state="errors.length > 0 ? false : null" />
                    </b-input-group>
                  </validation-provider>
                </b-form-group>
                <b-form-group class="mt-2" label-for="h-document">
                  <validation-provider #default="{ errors }" name="document">
                    <b-input-group>
                      <b-input-group-prepend>
                        <b-button v-ripple.400="'rgba(113, 102, 240, 0.15)'" class="btn-icon" :variant="errors.length > 0 ? 'outline-danger' : 'outline-primary'" v-b-tooltip.hover="'Conditions generale'" @click="openFileConditionsGenerale">
                          <b-form-file type="file" id="openFileConditionsGenerale" class="d-none" v-model="composeData.fileConditionsGenerale" />
                          <feather-icon icon="UploadCloudIcon" />
                        </b-button>
                      </b-input-group-prepend>
                      <b-form-input disabled placeholder="Condition générale" :value="composeData.fileConditionsGenerale ? composeData.fileConditionsGenerale.name : ''" :state="errors.length > 0 ? false : null" />
                    </b-input-group>              
                  </validation-provider>
                </b-form-group>
                <b-form-group class="mt-2" label-for="h-document">
                  <validation-provider #default="{ errors }" name="document" >
                    <b-input-group>
                      <b-input-group-prepend>
                        <b-button v-ripple.400="'rgba(113, 102, 240, 0.15)'" class="btn-icon" :variant="errors.length > 0 ? 'outline-danger' : 'outline-primary'" v-b-tooltip.hover="'Notice d\'information'" @click="openFileNoticeInformation">
                          <b-form-file type="file" id="openFileNoticeInformation" class="d-none" v-model="composeData.fileNoticeInformation" />
                          <feather-icon icon="UploadCloudIcon" />
                        </b-button>
                      </b-input-group-prepend>
                      <b-form-input disabled placeholder="Notice D'information" :value="composeData.fileNoticeInformation ? composeData.fileNoticeInformation.name : ''" :state="errors.length > 0 ? false : null" />
                    </b-input-group>    
                  </validation-provider>
                </b-form-group> 
                <b-form-group class="mt-2" label-for="h-document">
                  <validation-provider #default="{ errors }" name="document" >
                    <b-input-group>
                      <b-input-group-prepend>
                        <b-button v-ripple.400="'rgba(113, 102, 240, 0.15)'" class="btn-icon" :variant="errors.length > 0 ? 'outline-danger' : 'outline-primary'" v-b-tooltip.hover="'Fiche d\'information et de conseil'" @click="openFileTableauGarantie">
                          <b-form-file type="file" id="openFileTableauGarantie" class="d-none" v-model="composeData.fileTableauGarantie" />
                          <feather-icon icon="UploadCloudIcon" />
                        </b-button>
                      </b-input-group-prepend>
                      <b-form-input disabled placeholder="Tableau de garantie" :value="composeData.fileTableauGarantie ? composeData.fileTableauGarantie.name : ''" :state="errors.length > 0 ? false : null" />
                    </b-input-group>    
                  </validation-provider>
                </b-form-group> 
                </app-collapse-item>
           </app-collapse>

           <!-- Type origine -->
         
           <b-form-group label="Type d'origine" label-for="Type-d'origine" style="margin-top: 10px;">
                <b-form-select
                v-model="composeData.origine"
                        :options="origine"
                        id="origine"
                        />
            </b-form-group>

            <b-form-group v-if="composeData.origine==='Autre'" label="Précisez" label-for="origineautre"
                    
                    >
                    
                        <b-form-input
                          id="origineautre"
                          placeholder="Précisez l’origine"
                          v-model="composeData.origineautre"
                        />
            </b-form-group>

            
            <validation-provider #default="{ errors }" name="createur">
              <b-form-group :state="errors.length > 0 ? false : null" label="Crée par" label-for="Crée-par">
                <v-select v-model="composeData.createur" :close-on-select="true" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" :options="commercialOptions" class="flex-grow-1" input-id="createur" label="nom" placeholder="Crée par">
                  <template #option="{ avatar, nom }">
                    <b-avatar :src="avatar" size="sm" />
                    <span class="ml-50"> {{ nom }}</span>
                  </template>

                  <template #selected-option="{ avatar, nom }">
                    <b-avatar :src="avatar" class="border border-white" size="sm" />
                    <span class="ml-50"> {{ nom }}</span>
                  </template>
                  <div slot="no-options">Aucune commercial disponible.</div>
                </v-select>
                <b-form-invalid-feedback :state="errors.length > 0 ? false : null">{{ errors[0] }} </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>


          <validation-provider #default="{ errors }" name="intermediaire">
            <b-form-group :state="errors.length > 0 ? false : null" label="Intermédiaire (s)" label-for="intermediaire">
              <v-select v-model="composeData.intermediaire" :close-on-select="true" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" :options="commercialOptions" class="flex-grow-1" input-id="createur" label="nom" placeholder="Intermédiaire (s)" multiple>
                <template #option="{ avatar, nom }">
                  <b-avatar :src="avatar" size="sm" />
                  <span class="ml-50"> {{ nom }}</span>
                </template>

                <template #selected-option="{ avatar, nom }">
                  <b-avatar :src="avatar" class="border border-white" size="sm" />
                  <span class="ml-50"> {{ nom }}</span>
                </template>
                <div slot="no-options">Aucune commercial disponible.</div>
              </v-select>
              <b-form-invalid-feedback :state="errors.length > 0 ? false : null">{{ errors[0] }} </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>


            <!-- Form Actions -->
            <div class="d-flex mt-2">
              <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" class="mr-2" variant="primary"
                        @click="recordContrat"
              > Enregistrer
              </b-button>
            </div>
          </b-form>
        </validation-observer>
      </template>
    </b-sidebar>
    <!-- <b-sidebar id="sidebar-importNewContratTier" bg-variant="white" sidebar-class="sidebar-lg"   ref="sideBarImportContratTier" shadow backdrop no-header right>
      <template #default="{ hide }">
        <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
          <h5 class="mb-0 text-uppercase text-primary font-weight-bolder">Importer un document</h5>

          <feather-icon class="ml-1 cursor-pointer" icon="XIcon" size="16" @click="hide" />
        </div>
        <validation-observer ref="validateImportContratRules">
         <b-form class="p-2" @submit.prevent="handleSubmit(onSubmit)" @reset.prevent="resetForm">

        <b-form-group label="Nature de document" label-for="h-famille">
              <validation-provider #default="{ errors }" name="nature de document" rules="required">
                <b-form-select id="h-famille-autre-document" v-model="famille" :options="optionsFamille" :state="errors.length > 0 ? false : null" @change="changeListoptionType()">
                  <template #first>
                    <b-form-select-option :value="null">-- Choisissez --</b-form-select-option>
                  </template>
                </b-form-select>
                <b-form-invalid-feedback :state="errors.length > 0 ? false : null">{{ errors[0] }}</b-form-invalid-feedback>
              </validation-provider>
            </b-form-group>

             <b-form-group label="Type de document" label-for="h-type">
              <validation-provider #default="{ errors }" name="type de document" rules="required">
                <b-form-select id="h-type-autre-document" v-model="composeData.idType" :options="optionsType" :state="errors.length > 0 ? false : null">
                  <template #first>
                    <b-form-select-option :value="null">-- Choisissez --</b-form-select-option>
                  </template>
                </b-form-select>
                <b-form-invalid-feedback :state="errors.length > 0 ? false : null">{{ errors[0] }}</b-form-invalid-feedback>
              </validation-provider>
            </b-form-group>
                  <b-form-group class="mt-2" label-for="h-document">
              <validation-provider #default="{ errors }" name="document" rules="required">
                <b-input-group>
                  <b-input-group-prepend>
                    <b-button v-ripple.400="'rgba(113, 102, 240, 0.15)'" class="btn-icon" :variant="errors.length > 0 ? 'outline-danger' : 'outline-primary'" v-b-tooltip.hover="'Parcourir le fichier'" @click="openToSelectFile">
                      <b-form-file type="file" id="fileautredocumentPro" class="d-none" v-model="composeData.file" />
                      <feather-icon icon="UploadCloudIcon" />
                    </b-button>
                  </b-input-group-prepend>
                  <b-form-input disabled placeholder="Choisissez un document" :value="composeData.file ? composeData.file.name : ''" :state="errors.length > 0 ? false : null" />
                </b-input-group>

                <b-form-invalid-feedback :state="errors.length > 0 ? false : null">{{ errors[0] }}</b-form-invalid-feedback>
              </validation-provider>
            </b-form-group>

            <div class="d-flex mt-2">
              <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" class="mr-2" variant="primary"
                 @click="recordDocument"
              > Enregistrer
              </b-button>
            </div>
          </b-form>
        </validation-observer>
      </template>
    </b-sidebar> -->
  </div>
</template>

<script>
import {
  BAvatar,
  BBadge,
  BButton,
  BForm,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BFormSelect,
  BFormTextarea,
  BFormSelectOption,
  BInputGroup,
  BSidebar,
  VBToggle,
  BFormFile,
  VBTooltip,
  BFormRadioGroup,
  BInputGroupPrepend,
  BOverlay,
  BFormRadio,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import flatPickr from 'vue-flatpickr-component'
import { required } from '@validations'
import vSelect from 'vue-select'
import Cleave from 'vue-cleave-component'
import moment from 'moment'
import { ref } from '@vue/composition-api'
// import documentService from '@/shared/services/documentService'
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'

export default {
  components: {
    BButton,
    BSidebar,
    BFormGroup,
    BFormInput,
    BForm,
    BInputGroup,
    BFormRadioGroup,
    BFormInvalidFeedback,
    BBadge,
    Cleave,
    vSelect,
    BFormSelect,
    flatPickr,
    BAvatar,
    VBTooltip,
    BFormTextarea,
    BFormSelectOption,
    BFormFile,
    // Form Validation
    ValidationProvider,
    ValidationObserver,
     BInputGroupPrepend,
    BOverlay,
    AppCollapse,
    AppCollapseItem,
    BFormRadio
  },
  directives: {
    'b-toggle': VBToggle,
    'b-tooltip': VBTooltip,
    Ripple
  },
  props: {
    contratId: {
      type: Number,
      // eslint-disable-next-line vue/require-valid-default-prop
      default: null,
    },
    isFormFicheTier: {
      type: Boolean,
      default: true,
      required: false
    },
    clientType: {
      type: String,
      // eslint-disable-next-line vue/require-valid-default-prop
      default: null,

    },
    clientId: {
      type: Number,
      // eslint-disable-next-line vue/require-valid-default-prop
      default: null,

    },

    commercialOptions: {
      type: Array,
      // eslint-disable-next-line vue/require-valid-default-prop
      default: [],
      required: true
    },
    risquesOptions: {
      type: Array,
      // eslint-disable-next-line vue/require-valid-default-prop
      default: [],
      required: true
    },
    assureursOptions: {
      type: Array,
      // eslint-disable-next-line vue/require-valid-default-prop
      default: [],
      required: true
    },
    dataSelectedForEdit: {
      type: Object,
      // eslint-disable-next-line vue/require-valid-default-prop
      default: () => {
        return {
            id: null,
            client: null,
            n_contrat: null,
            risque_id: null,
            assureur_id: null,
            date_effet: null,
            echeance_anniversaire: '',
            typeFractionnement: null,
            statut: null,
            conteur:0,
            modalite_paiement: null,
            commercial: null,
            budget: null,
            taux_commission: null,
            courtier_id: null,
        }
      },
      required: false
    },
    currentUser: {
      type: Object,
      default: null,
      required: false
    },
    prospectSelected: {
      type: Object,
      default: null,
      required: false
    }
  },
  data() {
    return {
      isRésilié: false,
      isTemporaire: false,
      validtaux_commission:null,
      validbudget:null,
      valdiation:null,
      counteur:0,
      max:5,
      showLoading: false,
      required,
      famille:null,
      optionsType:[],
      isUpdateAction: false,
      options: {
        number: {
          numeral: true,
          numeralThousandsGroupStyle: 'thousand',
          numeralDecimalMark: ',',
          delimiter: ' '
        },
        percent: {
          numeral: true,
          numeralThousandsGroupStyle: 'thousand',
          numeralDecimalMark: ',',
          numeralPositiveOnly: true
        },
        date: {
          date: true,
          delimiter: '/',
          datePattern: ['d','m'],

        }
        
      },
      origine:[
            { value: null, text: 'Choisissez' },
            { value: 'Co_courtage', text: 'Co-courtage' },
            { value: 'Indicateur_affaires', text: 'Indicateur d\'affaires' },
            { value: 'Weedo_market', text: 'Weedo market' },
            { value: 'Recommandation', text: 'Recommandation' },
            { value: 'Réseaux_sociaux', text: 'Réseaux sociaux' },
            { value: 'Autre', text: 'Autre' },
      ],
      configDate: {
        dateFormat: 'd/m/Y',
        allowInput: true,
        onKeyDown: (selectedDates, dateStr, instance, event) => {
          if (event.keyCode != 8) {
            var ele = document.activeElement
            var val = ele.value

            if ((val.length == 2 || val.length == 5) && ele.getAttribute('id')) {
              val += '/'
            }
            ele.value = val
            ele.dispatchEvent(new Event('input'))
          }
        }
      },
      optionsChangedToProspect: [
        {value: true, text: 'Oui'}  ,
        {value: false, text: 'Non'}
      ],
      statutOptions: [
        {
          value: 'EN_COURS',
          text: 'En cours'
        },
        
        {
          value: 'MISE_EN_DEMEURE',
          text: 'Mise en demeure'
        },
        {
          value: 'RESILIE',
          text: 'Résilié'
        },
        {
          value: 'SANS_EFFET',
          text: 'Sans effet'
        },
        {
          value: 'SUSPENDU',
          text: 'Suspendu'
        },
        {
          value: 'TEMPORAIRE',
          text: 'Temporaire'
        }
      ],
      typeFractionnementOptions: [
      {
          value: null,
          text: 'Choisissez'
        },
        {
          value: 'ANNUEL',
          text: 'Annuel'
        },
        {
          value: 'MENSUEL',
          text: 'Mensuel'
        },
        {
          value: 'PRIME_UNIQUE',
          text: 'Prime unique'
        },
        {
          value: 'SEMESTRIEL',
          text: 'Semestriel'
        },
        {
          value: 'TRIMESTRIEL',
          text: 'Trimestriel'
        },
        {
          value: 'VERSEMENTS_LIBRES',
          text: 'Versements libres'
        }
      ],
      modalitePaiementOptions: [
        {
          value: 'CB',
          text: 'CB'
        },
        {
          value: 'CHEQUE',
          text: 'Chèque'
        },
        {
          value: 'PRELEVEMENT',
          text: 'Prélèvement'
        }
      ],
      composeData: {
        id: null,
        client: null,
        description:null,
        idType:null,
        file:null,
        fileBulteinAdhésionSigne:null,

        fileConditionParticulier:null,
        fileFicheInformationConseil:null,
        fileIpid:null,
        fileConditionsGenerale:null,
        fileTableauGarantie:null,
        fileNoticeInformation: null,
        contrat_Id:null,
        client_Id:null,
        n_contrat: null,
        risque_id: null,
        assureur_id: null,
        date_effet: null,
        echeance_anniversaire: '',
        typeFractionnement: null,
        statut: null,
        modalite_paiement: null,
        commercial: null,
        budget: null,
        taux_commission: null,
        courtier_id: null,
        isChangedToProspect: false,
        concurrence: 0,
        origine : null,
        origineautre:null,
        createur : null,
        intermediaire:null

      },
      selected_client: null,
      selected_risque: null,
      selected_assureur: null,
      date_effet: null,
      date_creation: null,

      categories: [{
        1: 'PARTICULIER',
        2: 'PROFESSIONNEL',
        3: 'ENTREPRISE',
      },
        {
          1: 'light-danger',
          2: 'light-warning',
          3: 'light-success'
        }],
    }
  },
  watch: {
    'composeData.statut': {
      handler(val) {
        if (val === 'RESILIE') {
          this.isRésilié = true
        }else if(val === 'TEMPORAIRE'){
          this.isTemporaire = true;
        }
         else {
          this.isRésilié = false
          this.isTemporaire = false;

        }
      }
    },
    'composeData.date_effet': {
      handler(val) {
        if(this.dataSelectedForEdit.echeance_anniversaire !=''){
          this.dataSelectedForEdit.conteur += 1
          if(this.dataSelectedForEdit.conteur != 1)
            this.composeData.echeance_anniversaire = this.formatDateAdd(val)
          this.dataSelectedForEdit.conteur += 1
        }
        else{
          this.composeData.echeance_anniversaire = this.formatDateAdd(val)
        }      
      }
    },
    'composeData.echeance_anniversaire': {
      handler(val) {
        if(this.dataSelectedForEdit.echeance_anniversaire != '')
          this.composeData.echeance_anniversaire=this.dataSelectedForEdit.echeance_anniversaire
        if(this.composeData.echeance_anniversaire.length==0){
          this.valdiation=null
        }
        else{
          const jour = this.composeData.echeance_anniversaire.charAt(0)+this.composeData.echeance_anniversaire.charAt(1)
          const mois = this.composeData.echeance_anniversaire.charAt(3)+this.composeData.echeance_anniversaire.charAt(4)
          if(this.composeData.echeance_anniversaire.length==2){
          this.composeData.echeance_anniversaire+='/'
        }
          if ( (mois >= 1 && mois <= 12) && (jour >= 1 && jour <= 31) ){
            if(this.composeData.echeance_anniversaire.length<5){
              this.valdiation='taper DD/MM'
            }
            else{
              this.valdiation=null
            }
          }
          else{
            this.valdiation='taper DD/MM'
          }
        }
      }
    },
    'composeData.client': {
      handler(val) {
        this.composeData.isChangedToProspect = false
      }
    },
    'composeData.budget': {
      handler(val) {
        if(this.composeData.budget == ','){
          this.validbudget = 'champs prime invalide'
        }
        else if(this.composeData.budget.charAt(0) == ','){
          var taux = this.composeData.budget
          var output = [taux.slice(0, 0), '0',taux.slice(0)].join('')
          this.composeData.budget = output
        }
        else{
          this.validbudget = null
          if(this.composeData.budget.charAt(this.composeData.budget.length - 1) == ','){
            this.validbudget = 'champs prime invalide'
          }else{
            this.validbudget=null
          } 
        }
      }
    },
    'composeData.taux_commission':{
      handler(val) {
        if(this.composeData.taux_commission == ','){
          this.validtaux_commission = 'champs prime invalide'
        }
        else if(this.composeData.taux_commission.charAt(0) == ','){
          var taux = this.composeData.taux_commission
          var output = [taux.slice(0, 0), '0',taux.slice(0)].join('')
          this.composeData.taux_commission = output
        }
        else{
          this.validtaux_commission = null
          if(this.composeData.taux_commission.charAt(this.composeData.taux_commission.length - 1) == ','){
            this.validtaux_commission = 'champs prime invalide'
          }else{
            this.validtaux_commission=null
          } 
        }
      }
    },
    contratId:{
      immediate:true,
      handler(val){
       this.composeData.contrat_Id=val

      }
    },
    clientId:{
      immediate:true,
      handler(val){
       this.composeData.client_Id=val

      }
    },
    dataSelectedForEdit: {
      deep: true,
      handler(val) {
        if (this.isUpdateAction) {
          this.composeData.isChangedToProspect = false
          this.composeData = val
        } else {
          this.clearDataSideBar()
        }
      }
    }
  },
  mounted() {
      this.composeData.client = this.prospectSelected
  },
  computed: {
    categorieVariant() {
      const categorieColor = {
        /* eslint-disable key-spacing */
        PARTICULIER: 'light-danger',
        PROFESSIONNEL: 'light-warning',
        ENTREPRISE: 'light-success',
        /* eslint-enable key-spacing */
      }

      return categories => categorieColor[categories]
    },
  },
  created() {
    this.composeData.courtier_id = this.currentUser.courtier_user[0].courtier_id
  },
  methods: {
    // open File Document Souscription  // 
     openConditionParticulier: () => {
      document.getElementById('openConditionParticulier').click()
    },

     openBulteinAdhesionSigne: () => {
      document.getElementById('openBulteinAdhesionSigne').click()
    },
    openFicheInformationConseil: () => {
      document.getElementById('openFicheInformationConseil').click()
    },
  //Open File Document Produits // 
    openfileIpid: () => {
      document.getElementById('openfileIpid').click()
    },
    openFileConditionsGenerale: () => {
      document.getElementById('openFileConditionsGenerale').click()
    },
    openFileTableauGarantie: () => {
      document.getElementById('openFileTableauGarantie').click()
    },
    openFileNoticeInformation: () => {
      document.getElementById('openFileNoticeInformation').click()
    },
    hideSideBare() {
      this.$refs.sideBarContratTier.hide()
      this.clearDataSideBar()
    },
    // hideSideBareImportContrat() {
    //   this.$refs.sideBarImportContratTier.hide()
    // },
     clearDataSideBarImportContrat() {
       this.famille = null,
       this.composeData.idType=null,
       this.composeData.description=null,
       this.composeData.file=null,
       this.$refs.validateImportContratRules.reset()

     },
      openToSelectFile: () => {
      document.getElementById('fileautredocumentPro').click()
    },
   changeListoptionType() {
      if (this.famille) {
        this.composeData.idFamille = this.famille.id
        this.composeData.idType = null
        this.optionsType = []
        this.famille.typeDocument.forEach(el => {
          this.optionsType.push({
            value: el.id,
            text: el.type
          })
        })
      } else {
        this.composeData.idFamille = null
        this.composeData.idType = null
        this.optionsType = []
      }
    },
     recordDocument() {
      this.$refs.validateImportContratRules.validate().then(success => {
        if (success) {
          // Set formData

          const formData = new FormData()
          // Append the rest of your form data
          formData.append('tiers', this.composeData.id)
          formData.append('type_tiers',this.clientType)
          formData.append('file', this.composeData.file)
          formData.append('type_doc_id', this.composeData.idType)
          formData.append('courtier_id', this.composeData.courtier_id)
          formData.append('description', '')
          // formData.append('description', this.composeData.description)
          formData.append('contrat_id', this.composeData.contrat_Id)
          formData.append('client_id', this.composeData.client_Id)
          formData.append('etude_id', this.composeData.etude_id)
          // send request
          const config = { headers: { 'Content-Type': 'multipart/form-data' } }
          this.$http
            .post('/document/importerNewDocumentContrat', formData, config)
            .then(res => {
              if (res.data.success) {
                this.$emit('record-document-courtier-returned', res.data.data, res.data.message)
                this.messageToast(res.data.message, 'Succès', 'success')
                this.clearDataSideBarImportContrat()
                // this.hideSideBareImportContrat()
              } else {
                this.messageToast('Erreur lors de creation de nouveau document.', 'Erreur', 'error')
              }
            })
            .catch(err => {
              this.messageToast(err.response.data.errors[0], 'Erreur', 'error')
              console.error(err)
            })
        }
      })
    },

    // Methode additional
    formatDateAdd(date) {
      return date ? moment(date, 'DD/MM')
          .format('DD/MM') : ''
    },
    clearDataSideBar() {
      this.composeData.id = null
      this.composeData.client = null
      this.composeData.n_contrat = null
      this.composeData.risque_id = null
      this.composeData.assureur_id = null
      this.composeData.date_effet = null
      this.composeData.echeance_anniversaire = ''
      this.composeData.typeFractionnement = null
      this.composeData.statut = null
      this.composeData.modalite_paiement = null
      this.composeData.commercial = null
      this.composeData.budget = null
      this.composeData.taux_commission = null
      this.composeData.origine = null
      this.composeData.createur = null
      this.composeData.intermediaire = null
      this.composeData.origineautre = null
      this.composeData.isChangedToProspect = false
      this.$refs.contratComposeRules.reset()
    },
    // record Data contrat
    methodRecordData() {
      const formData = new FormData()
          // Append the rest of your form data
          formData.append('id', this.checkIsNull(this.composeData.id))
          formData.append('description', this.checkIsNull(this.composeData.description))
          formData.append('client', JSON.stringify(this.composeData.client))
          formData.append('commercial_id', this.checkIsNull(this.prospectSelected.commercial))
          formData.append('fileBulteinAdhésionSigne', this.checkIsNull(this.composeData.fileBulteinAdhésionSigne))
          formData.append('fileConditionParticulier', this.checkIsNull(this.composeData.fileConditionParticulier))
          formData.append('fileFicheInformationConseil', this.checkIsNull(this.composeData.fileFicheInformationConseil))
          formData.append('fileIpid', this.checkIsNull(this.composeData.fileIpid))
          formData.append('fileConditionsGenerale', this.checkIsNull(this.composeData.fileConditionsGenerale))
          formData.append('fileTableauGarantie', this.checkIsNull(this.composeData.fileTableauGarantie))
          formData.append('fileNoticeInformation', this.checkIsNull(this.composeData.fileNoticeInformation))     
          formData.append('contrat_Id', this.checkIsNull(this.composeData.contrat_Id))
          formData.append('client_Id', this.checkIsNull(this.composeData.client_Id))
          formData.append('n_contrat', this.checkIsNull(this.composeData.n_contrat))
          formData.append('risque_id', this.checkIsNull(this.composeData.risque_id))
          formData.append('assureur_id', this.checkIsNull(this.composeData.assureur_id))
          formData.append('date_effet', this.checkIsNull(this.composeData.date_effet))
          formData.append('echeance_anniversaire', this.checkIsNull(this.composeData.echeance_anniversaire))
          formData.append('typeFractionnement', this.checkIsNull(this.composeData.typeFractionnement))
          formData.append('statut', this.checkIsNull(this.composeData.statut))
          formData.append('modalite_paiement', this.checkIsNull(this.composeData.modalite_paiement))
          formData.append('commercial', JSON.stringify( this.checkIsNull(this.composeData.commercial)))
          formData.append('budget', this.checkIsNull(this.composeData.budget))
          formData.append('taux_commission', this.checkIsNull(this.composeData.taux_commission))
          formData.append('courtier_id', this.checkIsNull(this.composeData.courtier_id))
          formData.append('isChangedToProspect', this.checkIsNull(this.composeData.isChangedToProspect))
          formData.append('concurrence', this.checkIsNull(this.composeData.concurrence))
          formData.append('origine', this.checkIsNull(this.composeData.origine === 'Autre' ? this.composeData.origineautre : this.composeData.origine));
          formData.append('createur',JSON.stringify(this.composeData.createur))
          formData.append('intermediaire', JSON.stringify(this.composeData.intermediaire));
          // console.log(JSON.stringify(this.projet.client))

          const config = { headers: { 'Content-Type': 'multipart/form-data' } }
      // statutFiche
      this.showLoading = true
      this.$http
          .post('/contrat/recordContrat', formData, config)
          .then(res => {
            if (res.data.success) {
              this.showLoading = false
              this.messageToast(res.data.message, 'Succès', 'success')
              this.$emit('reloadTiersData')
              this.clearDataSideBar()
              this.hideSideBare()
            }
          })
          .catch(err => {
            this.showLoading = false
            this.messageToast(err.response.data.errors[0], 'Erreur', 'error')
            console.error(err)
          })

    },
    recordContrat() {
      this.$refs.contratComposeRules.validate()
          .then(success => {
            if (success) {
              if(this.valdiation == null && this.validbudget == null && this.validtaux_commission == null){
                this.methodRecordData()
              }
            }
          })
    }
  },
//  setup() {
//     const optionsFamille = ref([])
//     const fetchDocumentNatureWithTypes = documentService()
//     fetchDocumentNatureWithTypes
//       .then(success => {
//         optionsFamille.value = []
//            success.data.filter(function(a) {return a.libelle==="Documents de souscription" ||  a.libelle==='Documents produits';}).forEach(el => {
//           optionsFamille.value.push({
//             value: { id: el.id, typeDocument: el.documentype },
//             text: el.libelle
//           })
//         })
//       })
//       .catch(errors => {
//         console.log(errors)
//         optionsFamille.value = []
//       })

//     return {
//       fetchDocumentNatureWithTypes,
//       optionsFamille
//     }
//   }
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
@import '@core/scss/vue/libs/vue-select.scss';
</style>
